const mapSizes = {
  sm: "small",
  md: "medium"
}, mapRowSizes = {
  sm: 2,
  md: 3
};
export {
  mapRowSizes,
  mapSizes
};
//# sourceMappingURL=constanst.js.map
